import React from 'react';
import './index.scss';
import { ImagePreview } from 'tea-component';

export default function PreviewMirror({ img, text }: any) {
  return (
    <div className="dbo-preview-mirror">
      <div className="dbo-preview-mirror-tips">{text}</div>
      <div className="dbo-preview-mirror-img">
        <ImagePreview src={img} previewSrc={img} maskClosable modalClassName="dbo-preview-mirror-modal">
          {(open) => <img onClick={open} src={img} alt="" />}
        </ImagePreview>
      </div>
    </div>
  );
}
